import type { AxiosError } from 'axios';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { TransactionReceipt } from 'src/types/swr/response';
import { ethereumTxHashRegex } from 'src/utils/regex';

import useProvider from './useProivder';

type FetchParams = {
  url: string;
  txHash: string;
  body: {
    method: string;
    params: [];
  };
};

export function useTxInfoSWR(txHash: string, config?: SWRConfiguration) {
  const { provider } = useProvider();

  const fetcher = async (params: FetchParams) => {
    if (!ethereumTxHashRegex.test(params.txHash)) return null;

    return provider?.send(params.body.method, params.body.params) as Promise<TransactionReceipt>;
  };

  const { data, isValidating, error, mutate } = useSWR<TransactionReceipt | null, AxiosError>(
    { txHash, body: { method: 'eth_getTransactionReceipt', params: [txHash] } },
    fetcher,
    {
      dedupingInterval: 7000,
      refreshInterval: 9000,
      errorRetryCount: 0,
      isPaused: () => !txHash || !provider,
      ...config,
    },
  );

  return { data, isValidating, error, mutate };
}
